// Purpose: Table primitive shell. Header row with uppercase tracked
// labels, body rows with hairline separators, optional empty-state
// slot rendered in place of tbody when rows.length === 0.
//
// Structural shell for Phase 7.5 Commit 1; visual tuning against real
// admin dashboard mockups comes in a later commit.

import type { HTMLAttributes, ReactNode, TableHTMLAttributes } from 'react';
import { forwardRef } from 'react';

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  children?: ReactNode;
}

export const Table = forwardRef<HTMLTableElement, TableProps>(function Table(
  { className, children, ...rest },
  ref
) {
  return (
    <div className="overflow-x-auto bg-surface-elevated border border-border-default rounded-lg">
      <table
        ref={ref}
        className={[
          'w-full text-left',
          'border-collapse',
          '[&_th]:px-4 [&_th]:py-3 [&_th]:text-label [&_th]:uppercase [&_th]:text-fg-secondary [&_th]:bg-bg-tertiary',
          '[&_td]:px-4 [&_td]:py-3 [&_td]:text-body-m [&_td]:text-fg-primary',
          '[&_tr+tr]:border-t [&_tr+tr]:border-border-default',
          '[&_tbody_tr:hover]:bg-bg-tertiary/60',
          className ?? '',
        ].join(' ')}
        {...rest}
      >
        {children}
      </table>
    </div>
  );
});

export function TableEmpty({ children, className }: HTMLAttributes<HTMLDivElement>) {
  return (
    <tr>
      <td colSpan={999} className={['!py-10 text-center text-fg-muted', className ?? ''].join(' ')}>
        {children}
      </td>
    </tr>
  );
}
